import GiubileoSchedaListPage from "./pages/GiubileoSchedaListPage.vue";
import GiubileoSchedaEditPage from "./pages/GiubileoSchedaEditPage.vue";
export default { GiubileoSchedaListPage, GiubileoSchedaEditPage };
